import { InlineError } from "./Notifications/Error";

export const Message = ({
  label,
  placeholder,
  name,
  register,
  error,
  style,
  height = "h-40",
}) => {
  return (
    <div className="text-sm w-full">
      <label className="text-border font-semibold">{label}</label>
      <textarea
        className={`w-full mt-2 p-6 bg-white border border-grey-800 rounded ${
          error
            ? "border-red-600 border-2"
            : "focus:border-main focus:border-2"
        } ${style} ${height}`}
        placeholder={placeholder}
        name={name}
        {...(register && register(name))}
      ></textarea>
    </div>
  );
};

export const Select = ({ label, options, onChange }) => {
  return (
    <>
      <label className="text-border font-semibold">{label}</label>
      <select
        className="w-full mt-2 px-6 py-4 text-text bg-main border border-grey-800 rounded"
        onChange={onChange}
      >
        {options.map((o, i) => (
          <option key={i} value={o.value}>
            {o.title}
          </option>
        ))}
      </select>
    </>
  );
};

export const Input = ({
  label,
  placeholder,
  type,
  bg,
  register,
  name,
  value,
  onChange,
  error,
  style,
  labelStyle
}) => {
  return (
    <div className="text-sm w-full">
      <label className={`text-border font-semibold ${labelStyle}`}>{label}</label>
      <input
        name={name}
        value={value}
        onChange={onChange}
        {...(register && register(name))}
        type={type}
        placeholder={placeholder}
        autoFocus={false}
        className={`w-full text-sm mt-2 p-5 border border-grey-800 rounded text-main ${
          error
            ? "border-red-600 border-2"
            : "focus:border-main focus:border-2"
        }  ${style}  ${bg ? "bg-white" : "bg-dry"}`}
      />
    </div>
  );
};

export const LabelInput = ({
  label,
  name,
  type,
  isMandatory = true,
  register,
  error = false,
}) => {
  return (
    <div className="grid grid-cols-12 flex items-center mb-2">
      <div className="lg:col-span-3 col-span-5 text-sm font-light">
        {label}: {isMandatory && "*"}
      </div>
      <div className="lg:col-span-4 col-span-7">
        <Input
          placeholder=""
          name={name}
          type={type}
          bg={true}
          style={"p-2"}
          register={register}
          error={error}
        />
        {error && <InlineError text={error?.message} />}
      </div>
    </div>
  );
};
export const Header = ({ title, children }) => {
  return (
    <div>
      <hr />
      <h2 className={`${children ? "mt-5 mb-3" : "my-5"}  text-3xl text-bold`}>
        {title}
      </h2>
      {children}
      <hr />
    </div>
  );
};
export const CheckboxInput = ({ id, name, label, register }) => {
  return (
    <div className="flex items-center mb-1">
      <input
        id={id}
        className="w-4 h-4 accent-subMain shadow-lg shadow-water"
        type="checkbox"
        value={label}
        name={name}
        {...(register && register(name, {}))}
      />
      <label htmlFor={id} className="mx-3 text-sm cursor-pointer font-light">
        {label}
      </label>
    </div>
  );
};

export const RadioButtonInput = ({
  id,
  name,
  label,
  register,
  refer,
  value,
}) => {
  return (
    <div className="flex items-center mb-1">
      <input
        id={id}
        className="w-4 h-4 rounded-full accent-main"
        type="radio"
        value={value}
        name={name}
        {...(register && register(refer))}
      />
      <label htmlFor={id} className="mx-3 text-sm cursor-pointer font-light">
        {label}
      </label>
    </div>
  );
};
